import { isEitherNone } from "iotera-base/object";

export function getToken(domain) {
    const id = localStorage.getItem(`iotera-${domain}-id`);
    const token = localStorage.getItem(`iotera-${domain}-token`);
    if (isEitherNone(id, token)) {
        removeToken(domain);
        return null;
    }
    return { id, token }
}

export function setToken(domain, id, token) {
    localStorage.setItem(`iotera-${domain}-id`, id);
    localStorage.setItem(`iotera-${domain}-token`, token);
}

export function removeToken(domain) {
    localStorage.removeItem(`iotera-${domain}-id`);
    localStorage.removeItem(`iotera-${domain}-token`);
}